import "./Home.module.css";
import Header from "@/reusable_sections/Header";
import ModernWindowSolutions from "./sections/ModernWindowSolutions";
import TheDocmorissPromise from "./sections/TheDocmorissPromise";
import SolucoesEmSustentabilidadeEGestao from "./sections/SolucoesEmSustentabilidadeEGestao";
import ThreeStepSetup from "./sections/ThreeStepSetup";
import CustomerExperiences from "./sections/CustomerExperiences";
import OurOffices from "./sections/OurOffices";
import Faq from "./sections/Faq";
import Footer from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <title>Yonge Sheppard RMT & Facial Wellness | Premium Wellness North York</title>
      <Header />
      <ModernWindowSolutions />
      <TheDocmorissPromise />
      <SolucoesEmSustentabilidadeEGestao />
      <ThreeStepSetup />
      <CustomerExperiences />
      <OurOffices />
      <Faq />
      <Footer />
    </div>;
}